import validate from "F:/Github/dexon-technology/frontend/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.153.0_@vue+compiler-sfc@3.5.44_confbox@0.3.1_db0@0.3.4_dote_ryahtarybgy4ghlnucizrwdwwu/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "F:/Github/dexon-technology/frontend/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.153.0_@vue+compiler-sfc@3.5.44_confbox@0.3.1_db0@0.3.4_dote_ryahtarybgy4ghlnucizrwdwwu/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  access: () => import("F:/Github/dexon-technology/frontend/middleware/access.ts")
}